export const bulkTransferTypes = [ //value represents serviceName and processKey
  {
    label: 'IBTR – Branch Transfer Regular Policy',
    value: 'BULK_TRANSFER_FOR_IBTR_REGULAR',
  },
  {
    label: 'IBTR – Branch Transfer Acquisition Policy',
    value: 'BULK_TRANSFER_FOR_IBTR_ACQUISITION',
  },
  {
    label: 'CRCG – Course Change Policy',
    value: 'BULK_TRANSFER_FOR_CRCG_REGULAR',
  },
  {
    label: 'STCG – Stream Change Policy',
    value: 'BULK_TRANSFER_FOR_STCG_REGULAR',
  }
];

export const bulkTransferStatusDropdown = [
  { label: 'Success', value: 'SUCCESS' },
  { label: 'Failed', value: 'FAILED' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
]

export const tranferPolicyDropdown = [
  { label: 'Acquisition Policy', value: 'ACQUISITION' },
  { label: 'Regular Policy', value: 'REGULAR' },
]

export const EMPTY_FILTER_FORM = {
  // "serviceType": "BULK_TRANSFER",
  "transferTypes": [],   
  "statuses": [],   
  "transferPolicy": "",        
  "uploadedBy": "", 
  "processDate" : ""
}

export const bulkTransferUploadStatusInfoMap = {
    "SUCCESS" : {text : 'Success' , bgColor: "#BBE2CE", textColor: "#0B442D" },
    "FAILED" : {text : 'Failed' , bgColor: "#F9D9D7", textColor: "#B32306" },
    "PROCESSING" : {text : 'In Progress' , bgColor: "#FFEDC8", textColor: "#705010" },
}

export const bulkTransferPolicyStyleMap = {
    "REGULAR" : {text : 'Branch Regular' , bgColor: "#BBE2CE", textColor: "#0B442D" },
    "ACQUISITION" : {text : 'Branch Acquisition' , bgColor: "#BBE2CE", textColor: "#0B442D" },
} 

